export class CartEvent extends Event {
  /**
   * @type {object}
   */
  cart = null

  constructor(type, { cart, ...eventInitDict }) {
    super(type, eventInitDict)

    if (cart) {
      this.cart = cart
    }
  }
}

export class CartItemOptionalEvent extends CartEvent {
  constructor(type, { lineItem, ...eventInitDict }) {
    super(type, eventInitDict)

    if (lineItem) {
      this.lineItem = lineItem
    }
  }
}

export class CartItemEvent extends CartItemOptionalEvent {
  /**
   * @type {object}
   */
  lineItem = null

  constructor(type, { lineItem, ...eventInitDict }) {
    if (!lineItem) {
      throw new Error('lineItem is required in cart item event data')
    }

    super(type, { lineItem, ...eventInitDict })
  }
}

export class AddToCartEvent extends CartItemEvent {
  constructor(eventInitDict) {
    super('cart:add', eventInitDict)
  }
}

export class RemoveFromCartEvent extends CartItemEvent {
  constructor(eventInitDict) {
    super('cart:remove', eventInitDict)
  }
}

export class UpdateCartEvent extends CartItemEvent {
  constructor(eventInitDict) {
    super('cart:update', eventInitDict)
  }
}

export class CartErrorEvent extends CartEvent {
  /**
   * @type {Error}
   */
  error = null

  constructor({ error, ...eventInitDict }) {
    if (!error) {
      throw new Error('error is required in cart error event data')
    }

    super('cart:error', eventInitDict)

    this.error = error
  }
}

export class CartItemErrorEvent extends CartItemEvent {
  /**
   * @type {Error}
   */
  error = null

  constructor({ error, ...eventInitDict }) {
    if (!error) {
      throw new Error('error is required in cart item error event data')
    }

    super('cart:error', eventInitDict)

    this.error = error
  }
}

export class CartProcessingStartEvent extends CartItemOptionalEvent {
  constructor(eventInitDict = {}) {
    super('cart:processing:start', eventInitDict)
  }
}

export class CartProcessingEndEvent extends CartItemOptionalEvent {
  constructor(eventInitDict = {}) {
    super('cart:processing:end', eventInitDict)
  }
}

export class CartDiscountAppliedEvent extends CartEvent {
  constructor(eventInitDict = {}) {
    super('cart:discount:apply', eventInitDict)
  }
}

export class CartDiscountRemovedEvent extends CartEvent {
  constructor(eventInitDict = {}) {
    super('cart:discount:remove', eventInitDict)
  }
}
